import { useEffect, useRef, useState } from "react";
import logo from "../resources/images/logo-noshe.jpg";
import { observer } from "mobx-react";
import LoginPage from "../components/account/login";
import NavbarSearch from "./navbar-search";
import NavbarCart from "./navbar-cart";
import { useAuth } from "../contexts/auth-context";
import { useStores } from "../stores/root-store";
import Sidebar from "./sidebar";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPowerOff,
  faUser,
  faShoppingBag,
  faUserCog,
  faSearch,
} from "@fortawesome/free-solid-svg-icons";
import { useLocation } from "react-router-dom";

interface INavBar {
  bgClass?: string;
}

const NavBar = observer(({ bgClass }: INavBar) => {
  const { pathname } = useLocation();
  const { cartStore } = useStores();
  const { cartItemsCount } = cartStore;
  const [showLoginModal, setShowLoginModal] = useState(false);
  const [showUserMenus, setShowUserMenus] = useState(false);
  const [showCollapsedNav, setShowCollapsedNav] = useState(false);
  const [showProfileMenu, setShowProfileMenu] = useState(false);
  const {
    isAuthenticated,
    isShopAdmin,
    isShopUser,
    isShopCustomer,
    clearAuth,
    isMobileResolution,
  } = useAuth();
  const profileMenu = useRef<HTMLUListElement>(null);
  const isTableOrderRoute = pathname.includes("/tbl-orders");
  const showAdminMenus = isShopAdmin || isShopUser;

  useEffect(() => {
    const closeProfileMenus = (e: MouseEvent | TouchEvent) => {
      if (showProfileMenu && !profileMenu.current?.contains(e.target as Node)) {
        setShowProfileMenu(false);
      }
    };

    document.addEventListener("mousedown", closeProfileMenus);
    document.addEventListener("touchend", closeProfileMenus);

    return () => {
      document.removeEventListener("mousedown", closeProfileMenus);
      document.removeEventListener("touchend", closeProfileMenus);
    };
  }, [showProfileMenu]);

  return (
    <nav
      className={`navbar app-navbar navbar-expand-lg ${
        bgClass ?? "bg-default"
      } nav-dark d-flex`}
    >
      <div className="container">
        <a className="navbar-brand p-0 m-0" href="/">
          <img src={logo} height="60" alt="logo" />
        </a>

        {isMobileResolution && pathname !== "/" && <NavbarSearch />}
        {!isMobileResolution && (
          <div
            className={`collapse navbar-collapse${
              showCollapsedNav ? " show" : ""
            }`}
            id="navbarTogglerTop"
          >
            {pathname !== "/" && <NavbarSearch />}

            <ul className="navbar-nav d-flex align-items-center ms-auto">
              <li className="nav-item me-3">
                <a href="/" className="text-white text-decoration-none">
                  Home
                </a>
              </li>

              {!showAdminMenus && (
                <>
                  {/* <li className="nav-item ms-3 me-3">
                   <div className="text-white border border-1 h-100"></div>
                 </li> */}
                  <li className="nav-item me-3">
                    <a
                      href="#contactUs"
                      className="text-white text-decoration-none"
                    >
                      Contact Us
                    </a>
                  </li>
                  <li className="nav-item">
                    <NavbarCart cartItemsCount={cartItemsCount} />
                  </li>
                </>
              )}

              {isAuthenticated ? (
                <>
                  {showAdminMenus && (
                    <>
                      <li className="nav-item">
                        <a
                          href="#"
                          className="text-white text-decoration-none"
                          onClick={() => setShowUserMenus(true)}
                        >
                          Menu
                        </a>

                        {showUserMenus && (
                          <Sidebar
                            show={showUserMenus}
                            setShowModal={setShowUserMenus}
                          ></Sidebar>
                        )}
                      </li>
                      {isTableOrderRoute && (
                        <li className="nav-item ms-3">
                          <NavbarCart cartItemsCount={cartItemsCount} />
                        </li>
                      )}
                    </>
                  )}

                  <li className="nav-item dropdown ms-4 mt-2">
                    <a
                      href="#"
                      onClick={() => setShowProfileMenu(!showProfileMenu)}
                      role="button"
                      className={`dropdown-toggle text-white drophide ${
                        showProfileMenu ? "show" : ""
                      }`}
                      id="shopProfileMv"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      <FontAwesomeIcon icon={faUserCog} className="fa-2x" />
                      {/* <div className="">
                         <span className="badge rounded-5 btn-default p-2">
                           {firstName && surname
                             ? firstName.substring(0, 1) +
                               surname.substring(0, 1)
                             : userName.substring(0, 1)}
                           <span className="visually-hidden">User Name</span>
                         </span>
                       </div> */}
                    </a>
                    <ul
                      ref={profileMenu}
                      id="ulShopProfile"
                      className={`dropdown-menu dropdown-menu-start ${
                        showProfileMenu ? "show" : ""
                      }`}
                      aria-labelledby="shopProfileMv"
                      style={{ zIndex: 9999 }}
                    >
                      <li className="dropdown-item">
                        <a href="/account" className="nav-link">
                          <FontAwesomeIcon
                            icon={faUser}
                            className="text-primary me-3"
                          />
                          My Account
                        </a>
                      </li>
                      {isShopCustomer && (
                        <li className="dropdown-item">
                          <a href="/my-orders" className="nav-link">
                            <FontAwesomeIcon
                              icon={faShoppingBag}
                              className="text-success me-3"
                            />
                            My Orders
                          </a>
                        </li>
                      )}
                      <li>
                        <hr className="dropdown-divider" />
                      </li>
                      <li className="dropdown-item">
                        <a
                          href="#"
                          onClick={() => clearAuth()}
                          className="nav-link link-dark"
                        >
                          <FontAwesomeIcon
                            icon={faPowerOff}
                            className="text-danger me-3"
                          />
                          Logout
                        </a>
                      </li>
                    </ul>
                  </li>
                </>
              ) : (
                <>
                  <li className="nav-item ms-4">
                    <a
                      href="#"
                      className="text-white text-decoration-none"
                      onClick={() => setShowLoginModal(true)}
                    >
                      Login
                    </a>
                    {showLoginModal && (
                      <LoginPage
                        show={showLoginModal}
                        setShowModal={setShowLoginModal}
                      ></LoginPage>
                    )}
                  </li>
                </>
              )}
            </ul>
          </div>
        )}
      </div>
    </nav>
  );
});

export default NavBar;
